import { render, staticRenderFns } from "./attr-goods.vue?vue&type=template&id=2a7e2593&scoped=true&"
import script from "./attr-goods.vue?vue&type=script&lang=js&"
export * from "./attr-goods.vue?vue&type=script&lang=js&"
import style0 from "./attr-goods.vue?vue&type=style&index=0&id=2a7e2593&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7e2593",
  null
  
)

export default component.exports